/**
 * 工厂端页面的路由前缀。
 *
 * 同一屏有两个入口：工厂账号走 `/portal/...`；自营站（Strand）就是一家工厂，
 * 内部账号在 sitebox 里走 `/strand/...`，用的是同一份组件、同一套后端。
 * 页面里所有站内跳转都从这里拿前缀，不然点一下就从 sitebox 跳进工厂端的壳。
 *
 * 由 `SelfOperatedPortal` 挂载时设成 `/strand`、卸载时还原。
 */
let base = '/portal';

export function portalBase(): string {
  return base;
}

export function setPortalBase(next: string): void {
  base = next;
}
